import React from 'react';

export default class MainPage extends React.Component {
  render(){
    return (<div id="page-content-wrapper" className={this.props.className}>
      {this.props.children}
    </div>);
  }
}
